import UtilsSchema from "@repoflow/schema/utils";
import TypesSchema from "@common/schema/types";

import {
  orgId,
  workflowId,
  title,
  description,
  steps,
  subforms,
  tags,
  shareToken,
  publishedVersion,
  createdAt,
  updatedAt,
} from "./fields";

export default [
  ...UtilsSchema,
  ...TypesSchema,
  {
    id: "/Public/Workflow",
    type: "object",
    properties: {
      orgId,
      workflowId,
      title,
      description,
      steps,
      subforms,
      tags,
      shareToken,
      publishedVersion,
      createdAt,
      updatedAt,
    },
  },
  {
    // Deliberately narrow: you name a workflow and title it, then design its
    // steps on the edit screen. Asking for the steps in a create dialog is how
    // you get a form nobody finishes.
    id: "/Public/Workflow/Create",
    type: "object",
    properties: {
      workflowId,
      title,
      tags,
    },
    // Mirrors WorkflowInputCreate's non-null fields exactly. An empty
    // `required` array is what left assertValid unable to reject anything in
    // the project this shape came from (A9 in docs/datum-api.md).
    required: ["workflowId", "title"],
  },
  {
    // `workflowId` is absent on purpose: it is the range key, so an input
    // field for it would read as a rename and would in fact write a second
    // row, leaving the first orphaned.
    id: "/Public/Workflow/Update",
    type: "object",
    properties: {
      title,
      description,
      steps,
      subforms,
      tags,
    },
    // `title` is `String!` on WorkflowInputUpdate, so this cannot reject
    // anything GraphQL would have accepted — it only stops the model layer
    // being reachable with less than the contract promises.
    required: ["title"],
  },
];
